import { useFliptBoolean } from "@flipt-io/flipt-client-react";

export const useFliptBooleanLowercase = (
  flagKey: string,
  fallback: boolean,
  entityId: string | undefined
): boolean => {
  return useFliptBoolean(flagKey, fallback, entityId?.toLowerCase());
};
